import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap"; 
import { Link } from "react-router-dom";

import * as apiUrl from "../../apiUrl";

function LatestBlog() {
  
  const [LatestBlog, setLatestBlog] = useState({});

  useEffect(() => {
    const fetchLatestBlog = async () => {
      try {
        const response = await fetch(apiUrl.apiUrl + `/api/blogs/latest-blog`);
        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }
        const data = await response.json();
        setLatestBlog(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchLatestBlog();
  }, []);

  const extractFirstSentence = (htmlContent) => {
    const parser = new DOMParser();
    const parsedDocument = parser.parseFromString(htmlContent, "text/html");

    // Get the first paragraph
    const firstParagraph = parsedDocument.querySelector("p");

    if (firstParagraph) {
      
      let textContent = firstParagraph.textContent.trim();     
      const sentences = textContent.match(/[^.!?]+[.!?]/g);

      // Return the first sentence if available
      if (sentences && sentences.length > 1) {
        return sentences[0].trim();
      }
    }

    return ""; 
  };

  return ( 
      <section className="latest-blog-sec">
        <Container fluid>
          <Row className="flex-center latest-blog-content-row">
            <Col md={6} className="padding-zero">
              <div className="latest-blog-content-div" data-aos="fade-right">
                <h2 className="common-head goldenColor">
                  {LatestBlog.blog_title}
                </h2>
                <p className="common-para">
                  {extractFirstSentence(LatestBlog.description)}
                </p>

                <p className="common-para goldenColor">
                  Date: {LatestBlog.place} {LatestBlog.posting_date}
                </p>
                <Link
                  to={`/blog/${LatestBlog.slug}`}
                  className="marquis-roundededge-colored-button"
                >
                  Read More
                </Link>
              </div>
            </Col>
            <Col md={6} className="padding-zero">              
                <img
                  src={`${apiUrl.apiUrl}/${LatestBlog.side_image}`}
                  className="img-fluid"
                  alt="Buy property in Dubai"
                  data-aos="fade-left"
                />              
            </Col>
          </Row>
        </Container>
      </section> 
  );
}

export default LatestBlog;
